import React, { useEffect, useState } from "react";
import { Drawer, Select } from "antd";
import { findCombinations } from "../../pages/constant/utils";
import { ProductVariantDisplayType } from "../../pages/constant/Constants";

const DropDownVarient = ({
  variant_attribute,
  setValues,
  values,
  selectedVariant,
  product,
  index,
  setVariantDropdown,
}) => {
  const { Option } = Select;

  useEffect(() => {
    document.getElementsByClassName("ant-select-selector")[1].style.border =
      "1px solid #F2F2F2";
    document.getElementsByClassName(
      "ant-select-selector"
    )[1].style.borderRadius = "26px";
    document.getElementsByClassName(
      "ant-select-selector"
    )[1].style.backgroundColor = "#F2F2F2";
    document.getElementsByClassName("ant-select-selector")[1].style.alignItems =
      "center";
    document.getElementsByClassName("ant-select-selector")[1].style.height =
      "45px";
    // document.getElementsByClassName("ant-select-selection-placeholder")[0].style.color = "black";
  }, []);

  const categoryHandle = (values) => {
    setValues((prev) => ({ ...prev, [variant_attribute.name]: values }));
    setVariantDropdown(values)
  };

  const deSelectedVariant = (obj) => {
    if (
      Object.keys(values).includes(variant_attribute.name) &&
      values[variant_attribute.name] === obj[variant_attribute.name]
    ) {
      setValues((prev) => {
        delete prev[variant_attribute.name];
        return prev;
      });
    }
    return true;
  };
  return (
    <>
      <div style={{display:"flex", justifyContent:"space-between"}}>
          <label
            style={{
            fontFamily: "Montserrat",
            fontSize: "20px",
            fontWeight: "500",
            lineHeight: "22px",
            letterSpacing: "0em",
            textAlign: "left",
            }}
          >
            {variant_attribute.name}
          </label>
            {variant_attribute?.attachment ?
            <a href={variant_attribute.attachment} target="_blank">
            <img src={process.env.PUBLIC_URL + "/media/icons/size_guide_img.png"} style={{height:"24px", width:"24px"}} alt="" />
          <label 
              style={{
              fontFamily: "Montserrat",
              fontSize: "18px",
              fontWeight: "400",
              lineHeight: "22px",
              letterSpacing: "0em",
              textAlign: "left",
              marginLeft: "8px",
              cursor: "pointer",
          }}>
              {variant_attribute?.attachment_name}
          </label>
          </a>
          : null
          }
        </div>
      <div
        style={{
          width: "35%",
        }}
      >
        <div >
          <Select
            value={values?.[variant_attribute.name]}
            className="ant-select-selector"
            optionFilterProp="label"
            showArrow
            placeholder={"Select Variant"}
            style={{ margin: "20px 16px 16px 0px" }}
            onChange={(e) => {
              categoryHandle(e);
            }}
          >
            {variant_attribute.value.map((e) => (
              <Option
                disabled={
                  findCombinations({
                    data:
                      [
                        { ...product, variant_product: null },
                        ...product?.variant_product,
                      ] || [],
                    index,
                    variantAttributes: product.product_variant_attribute,
                    values,
                    availability: {
                      [variant_attribute.name]: e,
                    },
                  })?.length
                    ? false
                    : deSelectedVariant({
                        [variant_attribute.name]: e,
                      })
                }
                value={e}
              >
                {findCombinations({
                  data:
                    [
                      { ...product, variant_product: null },
                      ...product?.variant_product,
                    ] || [],
                  index,
                  variantAttributes: product.product_variant_attribute,
                  values,
                  availability: {
                    [variant_attribute.name]: e,
                  },
                })?.length ? (
                  e
                ) : (
                  <del>{e}</del>
                )}
              </Option>
            ))}
          </Select>
        </div>
      </div>
    </>
  );
};
export default DropDownVarient;
